import UpcomingPopulation from "./UpcomingPopulation.vue";

import PopulationOverview from "@/module/population/Overview";
import PatientRoutes from "@/module/patient/routes";

const OverviewRoute = {
  path: "",
  component: PopulationOverview,
  props: true,

  icon: "el-icon-odometer",
  text: "Overview",
};

export default [
  {
    path: "upcoming/:direction",
    component: UpcomingPopulation,
    props: true,

    children: [OverviewRoute, ...PatientRoutes], 
  }
];
